module.exports = __webpack_public_path__ + "pic5.jpg?71a35f0bd5450ea7456078b111dc34e7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/featured/pic5.jpg
// module id = 98
// module chunks = 13